import { FC } from 'react'
import { Button, ButtonProps } from '@material-ui/core'

export const ToggleButton: FC<{ selected: boolean } & ButtonProps> = ({ selected, ...rest }) => {
  if (selected) {
    return <Button {...rest} variant="contained" color="primary" />
  } else {
    return <Button {...rest} />
  }
}
